
/**
 * Provides access to the device's accelerometer.
 */
export class AccelerometerInput {
  constructor() {
    this._acceleration = { x: 0, y: 0, z: 0 };
    this._accelerationIncludingGravity = { x: 0, y: 0, z: 0 };
    this._rotationRate = { alpha: 0, beta: 0, gamma: 0 };
    this._isCapturing = false;
  }

  /**
   *  Retrieves the latest acceleration data.
   */
  acceleration() {
    return this._acceleration;
  }

  /**
   *  Retrieves the latest acceleration data including the effect of gravity.
   */
  accelerationIncludingGravity() {
    return this._accelerationIncludingGravity;
  }

  /**
   *  Retrieves the current rotation rate of the device.
   */
  rotationRate() {
    return this._rotationRate;
  }

  /**
   * Starts capturing accelerometer data.
   * It begins tracking device motion and orientation changes.
   */
  start() {
    if (this._isCapturing) {
      return;
    }

    if (typeof window != 'undefined') {
      this._handleMotion = event => {
        if (event.acceleration) {
          this._acceleration.x = event.acceleration.x || 0;
          this._acceleration.y = event.acceleration.y || 0;
          this._acceleration.z = event.acceleration.z || 0;
        }

        if (event.accelerationIncludingGravity) {
          this._accelerationIncludingGravity.x = event.accelerationIncludingGravity.x || 0;
          this._accelerationIncludingGravity.y = event.accelerationIncludingGravity.y || 0;
          this._accelerationIncludingGravity.z = event.accelerationIncludingGravity.z || 0;
        }

        if (event.rotationRate) {
          this._rotationRate.alpha = event.rotationRate.alpha || 0;
          this._rotationRate.beta = event.rotationRate.beta || 0;
          this._rotationRate.gamma = event.rotationRate.gamma || 0;
        }
      };

      window.addEventListener('devicemotion', this._handleMotion);
      this._isCapturing = true;
    }
  }

  /**
   *  Stops capturing accelerometer data.
   */
  stop() {
    if (!this._isCapturing) {
      return;
    }

    if (typeof window !== 'undefined') {
      window.removeEventListener('devicemotion', this._handleMotion);
    }
    this._isCapturing = false;
  }

  /**
   *  Checks if the device supports accelerometer input.
   */
  isSupported() {
    if (typeof window == 'undefined' || typeof DeviceMotionEvent == 'undefined') {
      return false;
    }
    return true;
  }

  eventFrameEnd() {
    // No-op for now
  }

  /**
   *  Requests user authorization to access the accelerometer on
   *  devices where explicit permission is required.
   */
  async requestAuthorization() {
    if (typeof DeviceMotionEvent.requestPermission === 'function') {
      try {
        const response = await DeviceMotionEvent.requestPermission();
        if (response === 'granted') {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    } else {
      return true;
    }
  }
}

